export default {
	props: {
		/**
		 * Large modal
		 */
		large: {
			type: Boolean,
			default: false,
		},
		/**
		 * When true, is shown.
		 */
		isShown: { type: Boolean },
		/**
		 * Text in header of dialog
		 */
		title: { type: String },
		/**
		 * When true, the header with the title and close icon button is shown.
		 */
		hasHeader: {
			type: Boolean,
			default: true
		},
		/**
		 * When true, the body has styling.
		 */
		hasBody: {
			type: Boolean,
			default: true
		},
		/**
		 * When true, the footer with the cancel and confirm button is shown.
		 */
		hasFooter: {
			type: Boolean,
			default: true
		},
		/**
		 * When true, the cancel button is shown.
		 */
		hasCancel: {
			type: Boolean,
			default: true,
		},
		/**
		 * When true, the confirm button is shown.
		 */
		hasConfirm: {
			type: Boolean,
			default: true,
		},
		/**
		 * Label of the confirm button.
		 */
		confirmLabel: { type: String, },
		/**
		 * When true, the confirm button is set to disabled.
		 */
		isConfirmDisabled: {
			type: Boolean,
			default: false,
		},
		/**
		 * Label of the cancel button.
		 */
		cancelLabel: { type: String, },
		/**
		 * When true, close icon in header shown.
		 */
		showHeaderClose: {
			type: Boolean,
			default: true
		},
		/**
		 * Optional style class for entire footer
		 */
		footerClass: {
			type: String,
			default: ''
		},
		/**
		 * Boolean indicating if clicking the overlay should close the overlay.
		 */
		shouldCloseOnOverlayClick: {
			type: Boolean,
			default: true
		},
		/**
		 * The intent of the Dialog. Used for the button.
		 */
		intent: {
			type: String,
			default: 'default'
		},
		/**
		 * Boolean indicating if clicking confirm should close the overlay.
		 */
		disableCloseOnConfirm: {
			type: Boolean,
			default: false
		},
		/**
		 * Boolean indicating if clicking cancel should close the overlay.
		 */
		shouldCloseOnCancel: {
			type: Boolean,
			default: true
		},
		/**
		 * Boolean indicating if esc should close the overlay
		 */
		shouldCloseOnEscapePress: {
			type: Boolean,
			default: true
		},
		/**
		 * Makes cancel and confirm buttons disabled without the cursor changing.
		 */
		busy: {
			type: Boolean,
			default: false,
		},
		/**
		 * Optional width of dialog
		 */
		width: { type: String },
		/**
		 * Optional styling of body
		 */
		bodyStyle: { type: String },
		/**
		 *	Optional Icon on header
		 */
		icon: { type: String },
		/**
		 *	Icontype: 'bp' or none.
		 */
		iconType: { type: String },
		/**
		 *	iconColor: Color of optional header icon
		 */
		iconColor: {
			type: String,
			default: 'neutral'
		},
		disableContainerFocus: {
			type: Boolean,
			default: false
		},
		/**
		 *	focusFirstOnShow: If true, query with focusQueryString and focus on first hit.
		 */
		focusFirstOnShow: {
			type: Boolean,
			default: false
		},
		/**
		 *	alwaysRememberFocus: If true, focus will be restored to where it was before opening the dialog when the dialog closes.
		 *  					 If false, focus will only be restored if the dialog is closed with cancel.
		 */
		alwaysRememberFocus: {
			type: Boolean,
			default: false,
		},
		/**
		 *	neverRememberFocus: If true, focus will not be restored even if alwaysRememberFocus is true.
		 *						If false, focus will be restored if the dialog is closed with cancel.
		 */
		neverRememberFocus: {
			type: Boolean,
			default: false,
		},
		/**
		 * keyListeners: An array containing all keyListeners that should be registered with this dialog.
		 * These listeners will only be called as long as the dialog is on the top of the stack.
		 * Must contain objects with structure { key: String, listener: function, [modifiers: object] }
		 * For more information about keyListeners see @/core/keydownController.js
		 * Note:
		 * Currently this prop should not be changed during the life of the dialog, as this might cause orphaned listeners.
		 * If you need to change listeners while the dialog is alive, you need to implement functionality for this.
		 * You can probably use a watcher on this prop to add/remove listeners or something like that.
		 */
		keyListeners: {
			type: Array,
			default() { return []; },

			validator(value) {

				if (!Array.isArray(value)) return false;

				return value.reduce((acc, { key, listener }) => (

					acc && typeof key === 'string' && typeof listener === 'function'

				), true);
			}
		},
		paddingModalBody: String,
	}
};